<script setup lang="ts">
import { currency } from '@/utils/currency';
import { userPictureUrl } from '@/utils/user-picture-url';

interface Props {
  promoCampaign: PromoCampaign
  loading: boolean
}

defineProps<Props>();

const emit = defineEmits<{
  (e: 'subscribe'): void
}>();
</script>
<template>
  <div
    class="flex flex-col items-center border p-4 md:px-4 md:py-2"
  >
    <img
      :src="userPictureUrl(promoCampaign.partnerAccount.pictureUrl)"
      class="h-12 w-12 rounded-full"
    >
    <a
      :href="`/socio/${promoCampaign.partnerAccount.id}`"
      class=" underline"
    >
      Tienda de {{ promoCampaign.partnerAccount.firstName }}
    </a>
    <p class="mt-6 text-xl font-semibold text-z-gray-800">
      {{ currency(promoCampaign.pricePerRedeem) }}
    </p>
    <p class="text-sm text-z-gray-800">
      por canje
    </p>
    <base-button
      class="mt-4 w-full"
      size="sm"
      :disabled="loading"
      @click="emit('subscribe')"
    >
      Participar
    </base-button>
  </div>
</template>
